import React from 'react';
import styles from './style.module.scss';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { LOCALE_CONNECTION_REQUEST_PATHS, Namespaces } from 'types/locales';

import type { ListingAgentInfo } from 'components/pages/address/public/components/listing-agent';

export default function ListingAgentInPvr({ agentInfo }: { agentInfo: ListingAgentInfo }) {
  const { t } = useTranslation(Namespaces.CONNECTION_REQUEST);
  const agentPic = agentInfo?.photo ? agentInfo?.photo : '/next/assets/images/agent-search/agent-default-profile-pic.png';

  return (agentInfo &&
    <div className={styles.component}>
      <div className={styles['content-container']}>
        <div className={styles['left-agent']}>
          <Image src={agentPic} alt={agentInfo?.firstName} className={styles['avatar-large']} width={60} height={60}/>
          <div className={styles['agent-info']}>
            <p className={styles['agent-grey-title']}>{t(LOCALE_CONNECTION_REQUEST_PATHS.LISTING_AGENT_TITLE, { defaultValue: 'LISTING AGENT' })}</p>
            <p className={styles['agent-name']}>{agentInfo?.firstName} {agentInfo?.lastName}</p>
            <p className={styles['agent-title']}>{agentInfo?.title || t(LOCALE_CONNECTION_REQUEST_PATHS.LISTING_AGENT_DEFAULT_TITLE, { defaultValue: 'eXp Realty Agent' })}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
